import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    marginBottom: pxToRem(36),
  },
  moduleHeader: {
    margin: `${pxToRem(18)} ${pxToRem(24)} ${pxToRem(36)}`,
    borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralTertiaryAlt}`,
  },
  moduleContent: {
    padding: `0 ${pxToRem(24)} 0 ${pxToRem(24)}`,
  },
  headingText: {
    fontSize: pxToRem(22),
    fontWeight: 300,
    color: theme.palette.neutralDark,
  },
  headingTextLabel: {
    fontSize: pxToRem(14),
    fontWeight: 600,
    color: theme.palette.neutralDark,
    marginBottom: pxToRem(5),
  },
  statementRow: {
    marginBottom: pxToRem(24),
  },
  messageBar: {
    color: theme.palette.neutralDark,
    selectors: {
      '.ms-MessageBar-icon i': {
        color: theme.palette.neutralDark,
      },
    },
  },
  noTransactionDataTitle: {
    color: theme.palette.neutralDark,
  },
  noTransactionDataMessage: {
    color: theme.palette.neutralDark,
    fontWeight: 400,
  },
  statementPortalText: {
    fontSize: pxToRem(12),
    lineHeight: pxToRem(16),
    fontWeight: 400,
    color: theme.palette.neutralSecondary,
  },
  infoMessage: {
    display: 'flex',
    alignItems: 'flex-start',
    color: theme.palette.neutralSecondary,
    paddingTop: pxToRem(10),
  },
  infoIcon: {
    position: 'relative',
    marginRight: pxToRem(6),
    color: theme.palette.neutralTertiary,
  },
  infoText: {
    fontSize: pxToRem(12),
    lineHeight: pxToRem(16),
    fontWeight: 400,
  },
  moduleIndentedContent: {
    display: 'block',
    paddingLeft: pxToRem(16),
    paddingRight: pxToRem(16),
  },
});
